module.exports = __webpack_public_path__ + "static/kamisato-ayato-selected-afe1fb10428a9e5298dd7ec3044c96bb.png";